import {observer} from 'mobx-react';
import React from 'react';
import {MultiMappingSelect} from './base/MultiMappingSelect';
import {SingleMappingSelect} from './base/SingleMappingSelect';
import {
  ClassroomStatus,
  ClassroomStatuses,
  ClassroomStatusLabels
} from '../../../scenes/classroom/models/classroom-models';

type ClassroomStatusOption = {
  value: ClassroomStatus;
  label: string;
};

const ClassroomStatusOptions: ClassroomStatusOption[] =
  ClassroomStatuses.map(status => ({
    value: status,
    label: ClassroomStatusLabels[status]
  }));

function getOptionValue(option: ClassroomStatusOption) {
  return option.value;
}

function getOptionLabel(option: ClassroomStatusOption) {
  return option.label;
}

type ClassroomStatusSelectProps = {
  value: ClassroomStatus | null;
  onChange: (userStatusType: ClassroomStatus | null) => void;
  onBlur?: () => void;
};

export class ClassroomStatusSelect extends React.Component<ClassroomStatusSelectProps> {
  render() {
    return (
      <SingleMappingSelect<ClassroomStatusOption, ClassroomStatus>
        options={ClassroomStatusOptions}
        value={this.props.value}
        getValue={getOptionValue}
        getLabel={getOptionLabel}
        onChange={this.props.onChange}
        onBlur={this.props.onBlur}/>);

  }
}

type ClassroomStatusesSelectProps = {
  value: ClassroomStatus[];
  onChange: (userStatusType: ClassroomStatus[]) => void;
  onBlur?: () => void;
};

@observer
export class ClassroomStatusesSelect extends React.Component<ClassroomStatusesSelectProps> {
  render() {
    return (
      <MultiMappingSelect<ClassroomStatusOption, ClassroomStatus>
        options={ClassroomStatusOptions}
        value={this.props.value}
        getValue={getOptionValue}
        getLabel={getOptionLabel}
        onChange={this.props.onChange}
        onBlur={this.props.onBlur}
      />
    );
  }
}
